import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { reserveSlot } from "../../Services/ReservationService";
import Loader from "../../Components/Core/Loader";

const ReserveCallback = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const verifyPayment = useCallback(async () => {
    const authority =
      searchParams.get("Authority") ||
      searchParams.get("authority") ||
      searchParams.get("RefNum") ||
      searchParams.get("refNum");
    const rawStatus =
      searchParams.get("Status") ||
      searchParams.get("status") ||
      searchParams.get("State") ||
      searchParams.get("state") ||
      "";
    const status = rawStatus.toUpperCase();

    if (status === "NOK" || status === "CANCELED" || !authority) {
      localStorage.removeItem("reserveDetail");
      navigate("/reservation/detail/fail");
      return;
    }

    try {
      setLoading(true);
      const reserveDetail = JSON.parse(localStorage.getItem("reserveDetail"));

      const verificationResponse = await reserveSlot(reserveDetail, authority);

      localStorage.removeItem("reserveDetail");

      if (verificationResponse?.reservationId) {
        navigate(
          `/reservation/detail/success/${verificationResponse.reservationId}`
        );
      } else {
        navigate("/reservation/detail/fail");
      }
    } catch (error) {
      localStorage.removeItem("reserveDetail");
      console.error("Payment verification failed:", error);
      navigate("/reservation/detail/fail");
    } finally {
      setLoading(false);
    }
  }, [navigate, searchParams]);

  useEffect(() => {
    verifyPayment();
  }, [searchParams, verifyPayment]);

  return loading ? <Loader /> : null;
};

export default ReserveCallback;
